import React, { useEffect, useMemo, useState, useRef, createElement } from 'react';
import { Link } from 'react-router-dom';
const CENTER_IMAGE = 'https://cdn.magicpatterns.com/uploads/n2kNJrXXN5jB9ACfPQhrbc/Still_2026-06-02_012807_2.1.3.jpg';
const PERIL_WORD = 'constant peril';
const COLS = 8;
const ROWS = 30;
const TOTAL_SLOTS = COLS * ROWS;
const TICK_MS = 18;
function shuffle<T>(arr: T[]): T[] {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
export function Home() {
  // Easter egg state
  const [isPerilActive, setIsPerilActive] = useState(false);
  const [visible, setVisible] = useState<boolean[]>(() => new Array(TOTAL_SLOTS).fill(false));
  const revealOrderRef = useRef<number[]>([]);
  const tickRef = useRef<ReturnType<typeof setInterval> | null>(null);
  // Load the Laylo SDK once on mount so the embed renders
  useEffect(() => {
    const SRC = 'https://embed.laylo.com/laylo-sdk.js';
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  const handleImageClick = () => {
    if (isPerilActive) {
      if (tickRef.current) clearInterval(tickRef.current);
      tickRef.current = null;
      setIsPerilActive(false);
      setVisible(new Array(TOTAL_SLOTS).fill(false));
    } else {
      revealOrderRef.current = shuffle(Array.from({
        length: TOTAL_SLOTS
      }, (_, i) => i));
      setVisible(new Array(TOTAL_SLOTS).fill(false));
      setIsPerilActive(true);
    }
  };
  useEffect(() => {
    if (!isPerilActive) return;
    let step = 0;
    tickRef.current = setInterval(() => {
      if (step >= revealOrderRef.current.length) {
        if (tickRef.current) clearInterval(tickRef.current);
        tickRef.current = null;
        return;
      }
      const idx = revealOrderRef.current[step];
      step += 1;
      setVisible(prev => {
        const next = prev.slice();
        next[idx] = true;
        return next;
      });
    }, TICK_MS);
    return () => {
      if (tickRef.current) {
        clearInterval(tickRef.current);
        tickRef.current = null;
      }
    };
  }, [isPerilActive]);
  const slotIndices = useMemo(() => Array.from({
    length: TOTAL_SLOTS
  }, (_, i) => i), []);
  return <main className="relative min-h-screen w-full bg-white px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-222">
      {/* Top Header */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-223">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-224">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-225">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-226">
            catalog
          </Link>
          <Link to="/tour" className="lowercase hover:opacity-60" data-id="element-227">
            tour
          </Link>
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-228">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-229">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-230">
          contact
        </a>
      </header>

      {/* Cover art with easter egg */}
      <section className="mt-16 flex w-full justify-center md:mt-24" data-id="element-231">
        <button onClick={handleImageClick} aria-label="Toggle constant peril" className="relative block w-[560px] max-w-full md:w-[800px]" style={{
        cursor: 'pointer'
      }} data-id="element-232">
          <img src={CENTER_IMAGE} alt="Cover art" className="h-auto w-full" style={{
          mixBlendMode: 'multiply'
        }} draggable={false} data-id="element-233" />

          {isPerilActive && <div className="absolute inset-0 overflow-hidden bg-white" style={{
          fontFamily: '"Courier New", Courier, "SFMono-Regular", Menlo, Monaco, monospace',
          fontSize: '11px',
          lineHeight: '1',
          color: 'black',
          display: 'grid',
          gridTemplateColumns: `repeat(${COLS}, 1fr)`,
          gridTemplateRows: `repeat(${ROWS}, 1fr)`
        }} data-id="element-234">
              {slotIndices.map(i => <span key={i} className="flex items-center justify-center lowercase" style={{
            visibility: visible[i] ? 'visible' : 'hidden'
          }} data-id="element-235">
                  {PERIL_WORD}
                </span>)}
            </div>}
        </button>
      </section>

      {/* Sign up — Laylo embed */}
      <section className="mt-16 flex w-full flex-col items-center justify-center pb-24 text-sm md:mt-24" data-id="element-236">
        <div className="w-full max-w-md" data-id="element-237">
          <iframe id="laylo-drop-4ekga" frameBorder="0" scrolling="no" allow="web-share" allowTransparency title="Sign up" style={{
          width: '1px',
          minWidth: '100%',
          maxWidth: '1000px'
        }} src="https://embed.laylo.com?dropId=4ekga&color=000000&minimal=true&theme=light&background=transparent&customTitle=sign%20up" data-id="element-238" />
        </div>
      </section>
    </main>;
}